import { createSlice } from "@reduxjs/toolkit";

export const settings = createSlice({
  name: "settings",
  initialState: {
    settings: {
      allowAddToCart: false,
      showTouchPoints: false,
      dontRequireClientDetailsForPDF: true,
      filterQuery: "customerName=mlp",
      customerDisplayName: "MLPTEST",
      customerLogo: "/assets/imgs/mlp.png",
    },
  },
  reducers: {
    setSettings: (state, action) => {
      // Redux Toolkit allows us to write "mutating" logic in reducers. It
      // doesn't actually mutate the state because it uses the Immer library,
      // which detects changes to a "draft state" and produces a brand new
      // immutable state based off those changes
      const { settings } = action.payload;
      if (settings !== undefined) {
        state.settings = settings;
      }
    },
  },
});

// Action creators are generated for each case reducer function
export const { setSettings } = settings.actions;

export default settings.reducer;
